import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { sendPasswordResetEmail, updatePassword } from "firebase/auth";
import { auth } from "../firebase-config";
import logo from ".././Assets/logo.png";

const defaultTheme = createTheme();

export default function SignIn() {
  let navigate = useNavigate();
  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const email = data.get("email");
    try {
      await sendPasswordResetEmail(auth, email);
      toast.success(
        "Password reset email sent successfully. Please check your inbox."
      );
      navigate("/");
    } catch (error) {
      toast.error(`Sign up failed: ${error.message}`);
      console.log(error);
    }
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img style={{ margin: "10px" }} height="80px" src={logo} alt="" />
          <Box sx={{ border: "1px solid #dddddd", borderRadius: "10px" }}>
            <Box sx={{ padding: "40px" }}>
              <Typography
                sx={{ mb: "25px", color: "#4d4d4d" }}
                component="h1"
                variant="h5"
              >
                Reset Password
              </Typography>
              <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                sx={{ mt: 1, width: "320px" }}
              >
                <Typography sx={{ mb: "-10px", color: "#949494" }}>
                  Email
                </Typography>
                              <TextField
                                   hiddenLabel
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  placeholder="Enter email address"
                  name="email"
                  autoComplete="email"
                  autoFocus
                />
                {/* <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            /> */}
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={ { mt: 3, mb: 2 ,
                    backgroundColor: '#F2A040', borderColor: '#F2A040',boxShadow:'none', ":hover": {
                      borderColor:'#F2A040', backgroundColor: '#F2A040',color:'#ffffff', boxShadow:'none'
                    }
                  }}
                >
                  Sent reset link
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
}
